import React from 'react'
import { Admin, Resource, CustomRoutes } from 'react-admin'

import kampaayDataProvider from './services/api/dataProvider'
import './services/native-extensions'

import './App.css'

// resources
import Dashboard from './resources/dashboard/dashboard'
import events from './resources/operations/events'
import transaction from './resources/accounting/transaction'
import coupons from './resources/accounting/coupons'
import kampaayers from './resources/crm/kampaayers'
import suppliers from './resources/crm/suppliers'
import drinksSection from './resources/catalog/drink/sections'
import foodsSection from './resources/catalog/food/sections'
import drink from './resources/catalog/drink/product'
import eventPackage from './resources/catalog/packages/eventPackage/package'
import eventPackageSections from './resources/catalog/packages/eventPackage/sections'
import food from './resources/catalog/food/product'
import foodupselling from './resources/catalog/food/upselling'
import music from './resources/catalog/music/product'
import musicSections from './resources/catalog/music/sections'
import location from './resources/catalog/location/product'
import locationUpselling from 'resources/catalog/location/upselling'
import locationsFeatures from './resources/catalog/location/features'
import locationSections from './resources/catalog/location/sections'
import rent from './resources/catalog/rent/product'
import rentSections from './resources/catalog/rent/sections'
import virtualexperiences from './resources/catalog/virtualexperiences/product'
import virtualexperiencesSection from './resources/catalog/virtualexperiences/sections'
import virtualexperiencesupselling from './resources/catalog/virtualexperiences/upselling'
import physicalexperiences from './resources/catalog/physicalexperiences/product'
import physicalexperiencesSection from './resources/catalog/physicalexperiences/sections'
import physicalexperiencesUpselling from './resources/catalog/physicalexperiences/upselling'
import drinkPackage from './resources/catalog/packages/drinkPackage'
import musicpackage from './resources/catalog/packages/musicPackage'
import professionalpackage from './resources/catalog/packages/professionalPackage'
import rentpackage from './resources/catalog/packages/rentPackage'
import foodPackage from './resources/catalog/packages/foodPackage'
import locationPackage from './resources/catalog/packages/locationPackage'
import physicalPackage from './resources/catalog/packages/physicalPackage'
import facets from './resources/facets'
import logistics from './resources/catalog/logistics'
import professionalSections from './resources/catalog/professionals/sections'
import professionalFigures from './resources/catalog/professionals/p-figures'
import organization from './resources/crm/clients/organization'
import rules from './resources/catalog/rule'
import pmi from './resources/crm/clients/pmi'
// layout - this override default layout elements
import { Login, KLayout } from './layout'

import authProvider from './auth0Provider'
import { i18nProvider } from 'services/i18n'
import { LangContextProvider } from 'services/contexts/LangContext'
import { kampaayTheme } from 'layout/config/themes'
import servicesConfig from 'resources/services-config'
import { I18nBeComponent, I18nFeComponent } from 'routes'
import { Route } from 'react-router-dom'
import { QueryClient } from 'react-query'
import { PocResources } from 'poc'

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 3 * 60 * 1000, // 3 minutes
      },
    },
  })

  return (
    <LangContextProvider>
      <Admin
        dataProvider={kampaayDataProvider}
        loginPage={Login}
        authProvider={authProvider}
        layout={KLayout}
        dashboard={Dashboard}
        i18nProvider={i18nProvider}
        theme={kampaayTheme}
        queryClient={queryClient}
      >
        <CustomRoutes>
          <Route path="/i18n-panel-be" element={<I18nBeComponent />} />
          <Route path="/i18n-panel-fe" element={<I18nFeComponent />} />
        </CustomRoutes>
        {/* operations */}
        <Resource name="events" {...events} />
        <Resource name="eventsdraft" {...events} />
        {/* accounting */}
        <Resource name="transaction" {...transaction} />
        <Resource name="coupon" {...coupons} />
        {/* crm */}
        <Resource name="pmi" {...pmi} />
        <Resource name="kampaayers" {...kampaayers} />
        <Resource name="suppliers" {...suppliers} />
        <Resource name="organization" {...organization} />
        {/* catalog */}
        <Resource name="drinksections" {...drinksSection} />
        <Resource name="drinks" {...drink} />
        <Resource name="foods" {...food} />
        <Resource name="foodsections" {...foodsSection} />
        <Resource name="foodsupselling" {...foodupselling} />
        <Resource name="musics" {...music} />
        <Resource name="musicsections" {...musicSections} />
        <Resource name="rents" {...rent} />
        <Resource name="rentsections" {...rentSections} />
        <Resource
          name="virtualexperiencessections"
          {...virtualexperiencesSection}
        />
        <Resource name="virtuals" {...virtualexperiences} />
        <Resource name="virtualupselling" {...virtualexperiencesupselling} />
        <Resource name="professionalsections" {...professionalSections} />
        <Resource name="professionals" {...professionalFigures} />
        <Resource name="locations" {...location} />
        <Resource name="locationupselling" {...locationUpselling} />
        <Resource name="locationfeatures" {...locationsFeatures} />
        <Resource name="locationsections" {...locationSections} />
        <Resource name="physicals" {...physicalexperiences} />
        <Resource name="physicalsections" {...physicalexperiencesSection} />
        <Resource name="physicalupselling" {...physicalexperiencesUpselling} />
        <Resource name="rules" {...rules} />
        {/* Packages */}
        <Resource name="eventpackages" {...eventPackage} />
        <Resource name="eventpackagessections" {...eventPackageSections} />
        <Resource name="locationpackages" {...locationPackage} />
        <Resource name="drinkpackages" {...drinkPackage} />
        <Resource name="rentpackages" {...rentpackage} />
        <Resource name="musicpackages" {...musicpackage} />
        <Resource name="professionalpackages" {...professionalpackage} />
        <Resource name="foodpackages" {...foodPackage} />
        <Resource name="physicalpackages" {...physicalPackage} />

        {/* catalog */}
        <Resource name="facets" {...facets} />
        <Resource name="logistics" {...logistics} />
        <Resource name="servicesconfig" list={servicesConfig.edit} />
        {PocResources()}
      </Admin>
    </LangContextProvider>
  )
}

export default App
